<template>
    <div class="dashboard-wrapper flex flex-column gap-3 pt-2">
        <!-- Título Centralizado -->
        <div class="text-center py-2">
            <h1 class="m-0 text-4xl font-bold text-gray-100">{{ totalContratos }}</h1>
            <p class="m-0 text-orange-500 font-semibold text-lg">Meus Contratos</p>
        </div>

        <div class="flex gap-4 my-2 flex-column lg:flex-row">
            <!-- Gráfico 1: Minhas Etapas -->
            <div class="chart-card flex-1 p-4 border-round shadow-2">
                <h4 class="m-0 mb-4 text-orange-500 font-bold uppercase">MINHAS ETAPAS</h4>
                <StackedBarChart 
                    v-if="etapasUsuario?.labels?.length && etapasUsuario?.datasets?.length" 
                    :data="etapasUsuario" 
                    :colorMap="colorMap" 
                />
                <div v-if="isLoading.etapasUsuario" class="chart-loader">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <span>CARREGANDO GRÁFICO...</span>
                </div>
            </div>

            <!-- Gráfico 2: Meus Status de Etapa -->
            <div class="chart-card flex-1 p-4 border-round shadow-2">
                <h4 class="m-0 mb-4 text-orange-500 font-bold uppercase">MEUS STATUS DE ETAPA</h4>
                <StackedBarChart 
                    v-if="statusEtapasUsuario?.labels?.length && statusEtapasUsuario?.datasets?.length" 
                    :data="statusEtapasUsuario" 
                    :colorMap="statusColorMap" 
                />
                <div v-if="isLoading.statusEtapasUsuario" class="chart-loader">
                    <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="6" />
                    <span>CARREGANDO GRÁFICO...</span>
                </div>
            </div>
        </div>

        <!-- Tabela de Pendências -->
        <PendenciasTable 
            :lista="lista" 
            :loading="isLoadingLista" 
            @open-contrato="openFormContrato"
            @open-pendencia="openFormPendencia"
            @remove-pendencia="remove"
        />

        <PendenciaForm :visible="visibleFormPendencia" :data="item" @close="closeForm" @save="loadPendencias" />
        <ContratoForm :visible="visibleFormContrato" :id="item?.contrato_id" :permissoes="permissoes" @close="closeForm" @save="loadPendencias" />
    </div>
</template>

<script>
import StackedBarChart from './components/StackedBarChart.vue';
import ColorLegendCompact from './components/ColorLegendCompact.vue';
import PendenciasTable from './components/PendenciasTable.vue';

import Contrato from '@/service/contrato.js';
import Pendencia from '@/service/pendencia.js';

import PendenciaForm from '@/page/pendencia/Form.vue';
import ContratoForm from '@/page/contrato/Form.vue';
import ProgressSpinner from 'primevue/progressspinner';

export default {
    components: {
        StackedBarChart,
        ColorLegendCompact,
        PendenciasTable,
        PendenciaForm,
        ContratoForm,
        ProgressSpinner,
    },
    data() {
        return {
            lista: [],
            isLoadingLista: false,
            isLoading: {
                etapasUsuario: false,
                statusEtapasUsuario: false,
            },
            item: {},
            visibleFormPendencia: false,
            visibleFormContrato: false,

            totalContratos: 0,
            etapasUsuario: {},
            statusEtapasUsuario: {},

            permissoes: typeof permissoes !== 'undefined' ? permissoes : {},

            colorMap: {
                'Lead': '#3b82f6', // blue-500
                'Cotação': '#e11d48', // rose-600
                'Aguardando Aprovação': '#d97706', // amber-600
                'Provedor': '#eab308', // yellow-500
                'Assinatura': '#0f766e', // teal-700
                'Agendamento': '#8b5cf6', // violet-500
                'Instalação': '#64748b', // slate-500
                'Concluído': '#0ea5e9', // sky-500
                'Cancelado': '#ef4444' // red-500
            },

            statusColorMap: {
                'Status': '#3b82f6', // blue-500
                'Pendências': '#e11d48' // rose-600
            }
        }
    },
    beforeMount() {
        document.addEventListener("onPermissios", event => this.permissoes = event.permissoes);
    },
    mounted() {
        this.loadMeusContratos();
        this.loadMinhasEtapasSemanal();
        this.loadMinhasEtapasQuantidades();
        this.loadPendencias();
    },
    methods: {
        openFormPendencia(item) {
            this.item = { ...item };
            this.visibleFormPendencia = true;
        },
        openFormContrato(item) {
            this.item = { ...item };
            this.visibleFormContrato = true;
        },
        closeForm() {
            this.item = {};
            this.visibleFormPendencia = false;
            this.visibleFormContrato = false;
        },
        remove(item) {
            this.$confirm.require({
                message: 'Deseja realmente remover esta pendência?',
                header: 'Confirmação',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    Pendencia.delete(item.id).then(() => {
                        this.loadPendencias();
                        this.$toast.add({ severity: 'success', summary: 'Sucesso', detail: 'Pendência removida', life: 3000 });
                    });
                }
            });
        },
        loadPendencias() {
            this.isLoadingLista = true;
            Pendencia.list(['order[id]=asc', 'filter[resolvido]=0', 'limit=10'].join("&"))
                .then(response => {
                    this.lista = response.data.data;
                })
                .finally(() => this.isLoadingLista = false);
        },
        loadMinhasEtapasSemanal() {
            this.isLoading.etapasUsuario = true;
            let date = new Date();
            Contrato.minhasEtapasSemanal([`data=${date.toISOString().split('T')[0]}`].join("&"))
                .then(response => {
                    const data      = response.data.data;
                    const labels    = response.data.labels;
                    const datasets  = [];
                    data.forEach((item, idx) => {
                        item.etapas.forEach((item2, idx2) => {
                            if(!datasets[idx2]) {
                                datasets[idx2] = {
                                    label: item2.etapa,
                                    data: [],
                                }
                            }
                            datasets[idx2].data.push(item2.total);
                        });
                    });

                    this.etapasUsuario = {
                        labels: labels,
                        datasets: datasets,
                    }
                })
                .catch(e => {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar Minhas Etapas', life: 5000 });
                })
                .finally(() => {
                    this.isLoading.etapasUsuario = false;
                });
        },
        loadMinhasEtapasQuantidades() {
            this.isLoading.statusEtapasUsuario = true;
            Contrato.minhasEtapasQuantidade()
                .then(response => {
                    const data      = response.data.data;
                    const labels    = [];
                    const datasets  = [
                        { label: 'Status', data: [] },
                        { label: 'Pendências', data: [] }
                    ];
                    
                    data.forEach((item, idx) => {
                        if(!labels[idx]) {
                            labels[idx] = item.etapa;
                        }
                        datasets[0].data.push(item.total);
                        datasets[1].data.push(item.pendencias);
                    });

                    this.statusEtapasUsuario = {
                        labels: labels,
                        datasets: datasets,
                    }
                })
                .catch(e => {
                    this.$toast.add({ severity: 'error', summary: 'Erro', detail: 'Falha ao carregar Status de Etapas', life: 5000 });
                })
                .finally(() => {
                    this.isLoading.statusEtapasUsuario = false;
                });
        },
        loadMeusContratos() {
            Contrato.totalMeusContratos()
                .then(response => {
                    this.totalContratos = response.data.total
                });
        },
    }
}
</script>

<style scoped>
.chart-card {
    background-color: #1a1a1a;
    position: relative;
    overflow: hidden;
}
.chart-loader {
    position: absolute;
    top: 0; left: 0; right: 0; bottom: 0;
    background: rgba(26, 26, 26, 0.7);
    backdrop-filter: blur(2px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 10;
}
.chart-loader span {
    margin-top: 12px;
    font-size: 0.85rem;
    font-weight: 700;
    color: #f97316;
    letter-spacing: 0.05em;
}
</style>
